module.exports = __webpack_public_path__ + "static/media/logo_omy.c8b999c6.svg";